export function createLightText(color: string) {
	return `${color}-text text-lighten-2`;
}

export function createDarkText(color: string) {
	return `${color}-text text-darken-2`;
}